import React, { createContext, useReducer } from 'react';
import Reducer from './reducer';

const initialState = {
  values: {},
  valid: false,
};

const FormStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return <FormContext.Provider value={[state, dispatch]}>{children}</FormContext.Provider>;
};

export const FormInitialState = initialState;
export const FormContext = createContext(initialState);
export default FormStoreProvider;
